import React, { useState } from "react";
import CollapsibleSection from "./CollapsibleSection";
import BusinessHoursForm from "./BusinessHoursForm";

const BusinessHoursPanel = ({
    isOpen,
    onToggle,
    businesshoursRef,
    validationErrors,
    formData,
    setFormData,
    setValidationErrors
}) => {

    const [openPanel, setOpenPanel] = useState(null);

    return (
        <CollapsibleSection
            title="⏰ Business Hours"
            isOpen={isOpen}
            onToggle={onToggle}
        >
            <div
                ref={businesshoursRef} // ✅ attach the ref here
                className={`form-section ${openPanel ? " inline-hours-container-open3" : ""}`}
            >
                <label className="note hoursNote">
                    <input type="checkbox" checked={formData.byAppointmentOnly === true}
                        onChange={e => {
                            const checked = e.target.checked;
                            setFormData(prev => ({ ...prev, byAppointmentOnly: checked }));
                            setValidationErrors(prev => ({ ...prev, businessHours: !checked && !Object.values(formData.hours).some(day => !day.closed) }));
                        }} /> By Appointment Only
                </label>

                <small className="note hoursNote">
                    <span className="required">**</span> Use arrows to switch days. Uncheck 'Closed' to set open/close times.
                </small>
                {validationErrors.businessHours && !formData.byAppointmentOnly && (
                    <small className="field-error field-error-businesshours">
                        ** Select at least one open business day or By Appointment Only.
                    </small>
                )}
                {!formData.byAppointmentOnly && <div
                    className={`form-group ${openPanel ? " inline-hours-container-open2" : ""}`}
                >
                    <BusinessHoursForm
                        hours={formData.hours}
                        setHours={(updatedHours) => {
                            const isAnyOpen = Object.values(updatedHours).some(day => !day.closed);

                            setFormData((prev) => ({ ...prev, hours: updatedHours }));
                            setValidationErrors(prev => ({
                                ...prev,
                                businessHours: !formData.byAppointmentOnly && !isAnyOpen
                            }));
                        }}
                        openPanel={openPanel}
                        setOpenPanel={setOpenPanel}
                    />
                </div>}
            </div>
        </CollapsibleSection>
    );
};

export default BusinessHoursPanel;